// Portal-handoff snapshot helper (task 7.7a).
// Written before opening Paddle customer portal in a new tab so the return-
// detection diff in task 7.15 has a baseline. 2-hour TTL: if the user
// disappears for longer, we treat the snapshot as stale and skip the diff.

const KEY = 'billingPreHandoffSnapshot';
const TTL_MS = 2 * 60 * 60 * 1000;

export function writeBillingSnapshot(summary) {
  if (typeof window === 'undefined' || !summary) return;
  try {
    window.sessionStorage.setItem(
      KEY,
      JSON.stringify({
        paymentMethod: summary.paymentMethod ?? null,
        status: summary.status ?? null,
        plan: summary.plan ?? null,
        alternatePlanPrice: summary.alternatePlanPrice ?? null,
        capturedAt: Date.now(),
      }),
    );
  } catch { /* quota */ }
}

export function readBillingSnapshot() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.capturedAt || Date.now() - parsed.capturedAt > TTL_MS) {
      window.sessionStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch { return null; }
}

export function clearBillingSnapshot() {
  if (typeof window === 'undefined') return;
  try { window.sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}

// Computes the fields that changed between the snapshot and fresh summary.
// Used by the portal-return diff (task 7.15) to fire the right analytics event.
export function diffSnapshot(snapshot, fresh) {
  const changed = [];
  if (!snapshot || !fresh) return changed;
  if (JSON.stringify(snapshot.paymentMethod ?? null) !== JSON.stringify(fresh.paymentMethod ?? null)) changed.push('paymentMethod');
  if ((snapshot.status ?? null) !== (fresh.status ?? null)) changed.push('status');
  if (JSON.stringify(snapshot.plan ?? null) !== JSON.stringify(fresh.plan ?? null)) changed.push('plan');
  return changed;
}
